import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Background from "../../img/CourseIntroBackground.png";
import BackgroundDefuse from "../../img/CourseIntroBackgroundDefuse.svg";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    marginTop: "131px",
    height: isMobile ? "604px" : "467px",
    width: "100%",
    backgroundImage: `url(${Background})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  defuse: {
    height: "100%",
    width: "100%",
    backgroundImage: `url(${BackgroundDefuse})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  applyButton: {
    width: { xl: "314px", lg: "280px", md: "230px", xs: "197px" },
    height: { xl: "64px", lg: "60px", md: "45px", xs: "52px" },
    borderRadius: "100px",
    background: "linear-gradient(101deg, #f32c4d, #d00e2e 100%)",
    color: theme.palette.white.main,
    textTransform: "none",
    fontSize: { xl: "15.5px", md: "13px" },
    fontWeight: 550,
    marginTop: "43px",
  },
  buttonIcon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    color: "#d00e2e",
    bgcolor: theme.palette.white.main,
    ml: "3px",
    boxShadow:
      "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
  },
  icon: {
    width: "58px",
    height: "56px",
    borderRadius: "50%",
    border: "solid 2px #f4f4f4",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "5px",
  },
  typography: {
    title: {
      color: theme.palette.white.main,
      fontFamily: theme.typography.montserrat.bold,
      fontSize: { xl: "55px", lg: "55px", md: "55px", xs: "31px" },
      marginTop: isMobile ? "50px" : "102px",
      width: isMobile ? "230px" : "fit-content",
      textAlign: "center",
    },
    subtitle: {
      color: theme.palette.white.main,
      fontFamily: theme.typography.montserrat.light,
      fontSize: { xl: "25px", lg: "23px", md: "23px", xs: "23px" },
      width: { xl: "970px", lg: "900px", md: "850px", xs: "300px" },
      marginTop: isMobile ? "21px" : "36px",
    },
    shift: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: { xl: "22px", lg: "28px", md: "20px" },
      marginLeft: "5px",
    },
  },
});

const YourPace = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { title, subtitle, buttonText } = useTranslation(pathname, "YourPace");

  function goTo() {
    navigate(`../aplica/intro/formulario?modalidad=atr`);
  }

  return (
    <Box sx={classes.container}>
      <Box sx={classes.defuse}>
        <Typography sx={classes.typography.title}>{title}</Typography>
        <Typography sx={classes.typography.subtitle}>
          {subtitle[0]}
          <b>{subtitle[1]}</b>
          {subtitle[2]}
          <b>{subtitle[3]}</b>
          {subtitle[4]}
        </Typography>
        <Button
          sx={classes.applyButton}
          endIcon={<ArrowForwardIosIcon sx={classes.buttonIcon} />}
          onClick={goTo}
        >
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export default YourPace;
